import { useState,useEffect } from 'react';
import axiosInstance from '../../../helpers/axios';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import {
  Modal,
  Row,
  Col,
  Button,
  ModalBody,
  ModalHeader,
  ModalFooter
} from 'reactstrap';
import * as moment from 'moment';
import addNew from '../../../assets/images/Button.png';
import ViewFile from './viewFile.js';
import dele from '../../../assets/images/delete.png';
import downloadFile from '../../../assets/images/downloadFile.png';
import documentImage from '../../../assets/images/documenticon.png';
import eye from '../../../assets/images/eye.png';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import axios from 'axios';
import { Dialog, DialogTitle, DialogContent, LinearProgress, Typography } from '@mui/material';



import 'bootstrap/dist/css/bootstrap.min.css';
import { useCurrentUser } from '../../../hooks/useCurrentUser';


export default function Files({userId,appId,profileDetails}) {
  const location=useLocation()
  const decode = useCurrentUser();
  const user = null;
  const [downloadFileArray,setDownloadFileArray]=useState([])
const [arrayLength,setArrayLength]=useState(0)

const [file, setFile] = useState([]);
  const [fileSize, setFileSize] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState([]);
  let preview = '';
  const fileTypes = ['JPG', 'PNG', 'PDF', 'JPEG'];

  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [confirmationMessage, setConfirmationMessage] = useState('Hold On...');
  const [fileList,setFileList]=useState(null)

  const uploadedFileUrl=`/users/documents/admin?userId=${userId}`
  useEffect(() => {
   
    const controller = new AbortController();
  
    const fetchData = async () => {
      try {
        const [fileResponse] = await Promise.all([
          axiosInstance.get(uploadedFileUrl, {
            signal: controller.signal,
          }),
        
        ]);
        setFileList(fileResponse?.data?.data);
  
      } catch (err) {
        if (err.name !== 'CanceledError') {
          console.error("Failed to fetch data:", err);
        }
      } finally {
      }
    };
  
    fetchData();
  
    return () => {
      controller.abort();
    };
    
  }, [user,uploadedFileUrl]);

  const showUploadImage=(imgSrc)=>{

    setImageOpen(!imageOpen)
    setImageFile(imgSrc)

  }
  const handleChange = (currFile) => {
  const selectedFile = currFile[0];
  if (!selectedFile) return;

  setFile([selectedFile]);
  setUploaded(true);
  setFileSize(selectedFile.size);
  setFileType(selectedFile.type);
  setUploadedFileName(selectedFile.name);

  if (Type === 'voterid' || Type === 'voterid_front' || Type === 'voterid_back' || Type === 'driving_license_front' || Type === 'driving_license_back' || Type === 'passport' || Type === 'passport_front' || Type === 'passport_back') {
    // callDocumentOcr(selectedFile);
  } else {
    setOcrSuccess(true); 
  }
};


  preview = file ? URL.createObjectURL(new Blob(file, { type: 'application/jpg' })) : '#';
 // const location = useLocation();

  const [selectedValue, setSelectedValue] = useState('');

 const [id] = useState(userId);
  //file type enum
  const [Type, setType] = useState('');
  const [password, setPassword] = useState('');
  const [fileBinary, setFileBinary] = useState('');

  // handle onChange event of the select
  const handleSelect = (e) => {
    // When the combined Driving License option is selected
    if (e.id === 'driving_license') {
      setType('driving_license_front');
      setSelectedValue('Driving License - Front');
      setShowDrivingOptions(true);
      setShowVoterOptions(false);
      setShowPassportOptions(false);
      return;
    }

    // When the combined Voter ID option is selected
    if (e.id === 'voterid') {
      setType('voterid_front');
      setSelectedValue('Voter ID - Front');
      setShowVoterOptions(true);
      setShowDrivingOptions(false);
      setShowPassportOptions(false);
      return;
    }

    // When the combined Passport option is selected
    if (e.id === 'passport') {
      setType('passport_front');
      setSelectedValue('Passport - Front');
      setShowPassportOptions(true);
      setShowDrivingOptions(false);
      setShowVoterOptions(false);
      return;
    }

    // Default single-file option
    setShowDrivingOptions(false);
    setShowVoterOptions(false);
    setType(e.id);
    setSelectedValue(e.value);
  };

  // state to show separate front/back controls when Driving License is selected
  const [showDrivingOptions, setShowDrivingOptions] = useState(false);
  // state to show separate front/back controls when Voter ID is selected
  const [showVoterOptions, setShowVoterOptions] = useState(false);
  // state to show separate front/back controls when Passport is selected
  const [showPassportOptions, setShowPassportOptions] = useState(false);

  // states for driving license front/back files
  const [fileFront, setFileFront] = useState(null);
  const [fileBack, setFileBack] = useState(null);
  const [frontFileType, setFrontFileType] = useState(null);
  const [backFileType, setBackFileType] = useState(null);
  const [uploadedFrontName, setUploadedFrontName] = useState('');
  const [uploadedBackName, setUploadedBackName] = useState('');

  // states for voter id front/back files
  const [voterFileFront, setVoterFileFront] = useState(null);
  const [voterFileBack, setVoterFileBack] = useState(null);
  const [voterFrontFileType, setVoterFrontFileType] = useState(null);
  const [voterBackFileType, setVoterBackFileType] = useState(null);
  const [uploadedVoterFrontName, setUploadedVoterFrontName] = useState('');
  const [uploadedVoterBackName, setUploadedVoterBackName] = useState('');
  const [passportFileFront, setPassportFileFront] = useState(null);
  const [passportFileBack, setPassportFileBack] = useState(null);
  const [passportFrontFileType, setPassportFrontFileType] = useState(null);
  const [passportBackFileType, setPassportBackFileType] = useState(null);
  const [uploadedPassportFrontName, setUploadedPassportFrontName] = useState('');
  const [uploadedPassportBackName, setUploadedPassportBackName] = useState('');

const handleDrivingFileChange = (side, currFiles) => {
  const selected = currFiles && currFiles[0];
  if (!selected) return;

  if (side === 'front') {
    setFileFront(selected);
    setFrontFileType(selected.type);
    setUploadedFrontName(selected.name);
    processDrivingOcr(selected, 'driving_license_front');
  } else {
    setFileBack(selected);
    setBackFileType(selected.type);
    setUploadedBackName(selected.name);
    // Process OCR for back side only
    processDrivingOcr(selected, 'driving_license_back');
  }

  setUploaded(true);
};

  const selectDrivingSide = (side) => {
    if (side === 'front') {
      setType('driving_license_front');
      setSelectedValue('Driving License - Front');
    } else {
      setType('driving_license_back');
      setSelectedValue('Driving License - Back');
    }
  };

const [ocrLoading, setOcrLoading] = useState(false);
const [ocrSuccess, setOcrSuccess] = useState(false);
const [ocrData, setOcrData] = useState({});

const splitName = (fullName = '') => {
  const parts = fullName.trim().split(/\s+/);

  if (parts.length === 1) {
    return { firstName: parts[0], lastName: '' };
  }

  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(' ')
  };
};

const callDocumentOcr = async (fileObj) => {
  try {
    setOcrLoading(true);
    setOcrSuccess(false);

    const formData = new FormData();
    formData.append('aadhaarFront', '');
    formData.append('aadhaarBack', '');
    formData.append('pan', '');
    formData.append('others', fileObj);

    const response =  await axiosInstance.post('/ocr/read', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    const ocr = response.data?.data?.id || {};
    const { firstName, lastName } = splitName(ocr.name);

    const parsed = {
      name: ocr.name || '',
      firstName,
      lastName,
      idNumber: ocr.id_no || '',
      passportNumber: ocr.id_no || '',
      dob: ocr.dob || '',
      expiryDate: ocr.date_of_expiry || '',
      gender: ocr.gender || ''
    };
    return parsed;
  } catch (err) {
    alert('OCR failed');
    setOcrSuccess(false);
    return null;
  } finally {
    setOcrLoading(false);
  }
};

const processDrivingOcr = async (currentFile, currentSide) => {
  if (!currentFile) return;

  const parsedData = await callDocumentOcr(currentFile);
  
  if (!parsedData) {
    setOcrSuccess(false);
    return;
  }

  // Check if new parsed data has ANY useful information
  const newDataHasInfo = parsedData.name || parsedData.idNumber || parsedData.dob;

  if (!newDataHasInfo) {
    // New data has nothing useful, keep existing
    setOcrSuccess(true); // Keep success state if we already had data
    return;
  }

  // Set the current side as active type
  setType(currentSide);

  // Merge data - ONLY update fields where new data is NOT empty
  setOcrData(prev => ({
    ...(prev || {}),
    // Only update if new value exists (not empty string)
    name: parsedData.name ? parsedData.name : (prev?.name || ''),
    idNumber: parsedData.idNumber ? parsedData.idNumber : (prev?.idNumber || ''),
    dob: parsedData.dob ? parsedData.dob : (prev?.dob || ''),
    expiryDate: parsedData.expiryDate ? parsedData.expiryDate : (prev?.expiryDate || ''),
    gender: parsedData.gender ? parsedData.gender : (prev?.gender || '')
  }));
  
  setOcrSuccess(true);
};

// helper to select which side of voter id is being uploaded
const selectVoterSide = (side) => {
  if (side === 'front') {
    setType('voterid_front');
    setSelectedValue('Voter ID - Front');
  } else {
    setType('voterid_back');
    setSelectedValue('Voter ID - Back');
  }
};

// handle file pick for voter id sides
const handleVoterFileChange = (side, currFiles) => {
  const selected = currFiles && currFiles[0];
  if (!selected) return;

  if (side === 'front') {
    setVoterFileFront(selected);
    setVoterFrontFileType(selected.type);
    setUploadedVoterFrontName(selected.name);
    processVoterOcr(selected, 'voterid_front');
  } else {
    setVoterFileBack(selected);
    setVoterBackFileType(selected.type);
    setUploadedVoterBackName(selected.name);
    processVoterOcr(selected, 'voterid_back');
  }

  setUploaded(true);
};

// Process OCR for voter id — only merge name and idNumber (no dob)
const processVoterOcr = async (currentFile, currentSide) => {
  if (!currentFile) return;

  const parsedData = await callDocumentOcr(currentFile);
  if (!parsedData) {
    setOcrSuccess(false);
    return;
  }

  const newDataHasInfo = parsedData.name || parsedData.idNumber;
  if (!newDataHasInfo) {
    setOcrSuccess(true);
    return;
  }

  setType(currentSide);
  setOcrData(prev => ({
    ...(prev || {}),
    name: parsedData.name ? parsedData.name : (prev?.name || ''),
    idNumber: parsedData.idNumber ? parsedData.idNumber : (prev?.idNumber || '')
  }));

  setOcrSuccess(true);
};

// helpers for passport front/back
const selectPassportSide = (side) => {
  if (side === 'front') {
    setType('passport_front');
    setSelectedValue('Passport - Front');
  } else {
    setType('passport_back');
    setSelectedValue('Passport - Back');
  }
};

const handlePassportFileChange = (side, currFiles) => {
  const selected = currFiles && currFiles[0];
  if (!selected) return;

  if (side === 'front') {
    setPassportFileFront(selected);
    setPassportFrontFileType(selected.type);
    setUploadedPassportFrontName(selected.name);
    processPassportOcr(selected, 'passport_front');
  } else {
    setPassportFileBack(selected);
    setPassportBackFileType(selected.type);
    setUploadedPassportBackName(selected.name);
    processPassportOcr(selected, 'passport_back');
  }

  setUploaded(true);
};

// Process OCR for passport — merge passportNumber, dob, expiryDate, gender, name
const processPassportOcr = async (currentFile, currentSide) => {
  if (!currentFile) return;

  const parsedData = await callDocumentOcr(currentFile);
  if (!parsedData) {
    setOcrSuccess(false);
    return;
  }

  const newDataHasInfo = parsedData.name || parsedData.passportNumber || parsedData.dob;
  if (!newDataHasInfo) {
    setOcrSuccess(true);
    return;
  }

  setType(currentSide);
  setOcrData(prev => ({
    ...(prev || {}),
    name: parsedData.name ? parsedData.name : (prev?.name || ''),
    passportNumber: parsedData.passportNumber ? parsedData.passportNumber : (prev?.passportNumber || ''),
    dob: parsedData.dob ? parsedData.dob : (prev?.dob || ''),
    expiryDate: parsedData.expiryDate ? parsedData.expiryDate : (prev?.expiryDate || ''),
    gender: parsedData.gender ? parsedData.gender : (prev?.gender || '')
  }));

  setOcrSuccess(true);
};

const handleOcrInputChange = (field, value) => {
  setOcrData(prev => {
    const updated = { ...prev, [field]: value };
    return updated;
  });
};

const [verifyLoading, setVerifyLoading] = useState(false);
const [verifyError, setVerifyError] = useState('');
const [verifySuccess, setVerifySuccess] = useState('');

const formatDob = (dob) => {
  if (!dob) return '';
  const [dd, mm, yyyy] = dob.includes('/')
    ? dob.split('/')
    : dob.split('-');
  return `${dd}-${mm}-${yyyy}`;
};
const handleVerifyAndSubmit = async () => {
  try {
    setVerifyLoading(true);
    setVerifyError('');

    let verifyResponse;

    if (Type === 'voterid' || Type === 'voterid_front' || Type === 'voterid_back') {
      verifyResponse = await axiosInstance.post(
        '/voter-id',
        {
          applicationId: appId,
          userId,
          customerEpicNumber: ocrData.idNumber,
          name: profileDetails?.firstName + ' ' + profileDetails?.lastName,
          currentState: profileDetails?.currentState,
          instituteId: profileDetails?.instituteId
        }
      );
    }

    if (Type === 'driving_license_front' || Type === 'driving_license_back') {
      verifyResponse = await axiosInstance.post(
        '/driving-license',
        {
          applicationId: appId,
          userId,
          licenseNumber: ocrData.idNumber,
          name: profileDetails?.firstName + ' ' + profileDetails?.lastName,
          dob: formatDob(ocrData.dob),
          currentState: profileDetails?.currentState,
          instituteId: profileDetails?.instituteId
        }
      );
    }
    
    if (Type === 'passport' || Type === 'passport_front' || Type === 'passport_back') {
      verifyResponse = await axiosInstance.post(
        '/passport',
        {
          applicationId: appId,
          userId,
          passportNumber: ocrData.passportNumber,
          firstName: profileDetails.firstName,
          lastName: profileDetails.lastName,
          gender: ocrData.gender === "male" ? 'M' : 'F',
          dob: ocrData.dob,
          expiryDate: ocrData.expiryDate,
          instituteId: profileDetails?.instituteId
        }
      );
    }

    const result = verifyResponse?.data?.data;

    if (
      result === 'Verification failed' ||
      result === 'No Record Found'
    ) {
      setVerifyError(result);  
      handleSubmission(file);
      return;                  
    }
    setVerifySuccess('Verification successful');
    handleSubmission(file);

  } catch (err) {
    setVerifyError('Verification service unavailable. Please try again.');
  } finally {
    setVerifyLoading(false);
  }
};


  const DocCreate = (resp, overrideType) => {
    const effectiveType = overrideType || Type;
   
    let docData = null;
    if (userId) {
      setConfirmationDialog(!confirmationDialog);
      // If this is NOT a "back" side (we store in url1)
      if (effectiveType !== "driving_license_back" && effectiveType !== "aadhaar_back" && effectiveType !== "voterid_back" && effectiveType !== "passport_back") {
        docData = {
          userId: userId,
          doneBy: decode.display_name,
          type: effectiveType === "driving_license_front" || effectiveType === "driving_license_back" ? "driving_license" :
                effectiveType === "aadhaar_front" || effectiveType === "aadhaar_back" ? "aadhaar" :
                effectiveType === "voterid_front" || effectiveType === "voterid_back" ? "voterid" :
                effectiveType === "passport_front" || effectiveType === "passport_back" ? "passport" : effectiveType,
          documentPassword: password,
          url1: resp?.data?.data?.s3Url,
        };
      }
      // back side -> save to url2
      else if (effectiveType === "driving_license_back" || effectiveType === "aadhaar_back" || effectiveType === "voterid_back" || effectiveType === "passport_back") {
        docData = {
          userId: userId,
          doneBy: decode.display_name,
          type: effectiveType === "driving_license_front" || effectiveType === "driving_license_back" ? "driving_license" :
                effectiveType === "aadhaar_front" || effectiveType === "aadhaar_back" ? "aadhaar" :
                effectiveType === "voterid_front" || effectiveType === "voterid_back" ? "voterid" :
                effectiveType === "passport_front" || effectiveType === "passport_back" ? "passport" : effectiveType,
          url2: resp.data.data.s3Url,
          documentPassword: password,
        };
      }

      axiosInstance.post(`/users/documents/create/admin`, docData, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(
          (res) => {
            setConfirmationMessage('Uploaded Successfully');
            setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
            setTimeout(() => setConfirmationDialog(false), 2000);
            setTimeout(() => window.location.reload(true), 2000);
          },
          (error) => {
            setConfirmationMessage('Upload was Unsuccessful...!');
            setTimeout(() => setConfirmationDialog(!confirmationDialog), 3000);
            setTimeout(() => setConfirmationDialog(false), 3000);
          },
        );
    } else {
      alert('Fill all mandatory fields');
    }
  };

  const handleSubmission = (item) => {
    // If Driving License, Voter ID or Passport combined option is selected, upload front and back separately (if present)
    if (showDrivingOptions || showVoterOptions || showPassportOptions) {
      const uploadSide = async (sideFile, sideType) => {
        if (!sideFile) return;
        const fd = new FormData();
        fd.append('file', sideFile);
        fd.append('type', sideType);

        if (sideType === 'video') {
          await uploadVideoToS3(sideFile, sideType);
          return;
        }

        try {
          if (sideType === 'delivery_order') {
            const response = await axiosInstance.post(`/admin/application/upload-do?userId=${userId}&applicationId=${appId}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            DocCreate(response, sideType);
            return;
          }

          if (sideType === 'excel') {
            const response = await axiosInstance.post(`/file/upload-excel`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            DocCreate(response, sideType);
            return;
          }

          // default file upload
          const response = await axiosInstance.post(`/file/upload`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
          DocCreate(response, sideType);
        } catch (err) {
          alert('Failed to upload, Please check fields and file format');
        }
      };

      setSubmitting(true);
      (async () => {
        try {
          if (showDrivingOptions) {
            await uploadSide(fileFront, 'driving_license_front');
            await uploadSide(fileBack, 'driving_license_back');
          } else if (showVoterOptions) {
            await uploadSide(voterFileFront, 'voterid_front');
            await uploadSide(voterFileBack, 'voterid_back');
          } else if (showPassportOptions) {
            await uploadSide(passportFileFront, 'passport_front');
            await uploadSide(passportFileBack, 'passport_back');
          }
        } finally {
          setSubmitting(false);
        }
      })();

      return;
    }

    const data = new FormData();
    data.append('file', item[0]);
    data.append('type', Type);
    setSubmitting(true);

    if (Type === 'video') {
      // Upload video via S3 pre-signed URL
      uploadVideoToS3(file[0], Type);
      return;
    }

    const onError = (msg) => { setSubmitting(false); alert(msg); };

    if (Type === 'delivery_order') {
      axiosInstance.post(`/admin/application/upload-do?userId=${userId}&applicationId=${appId}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => { setSubmitting(false); DocCreate(response); })
        .catch(() => onError('Failed to upload, Please check fields and file format'));
      return;
    }

    if (Type === 'excel') {
      axiosInstance.post(`/file/upload-excel`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => { setSubmitting(false); DocCreate(response); })
        .catch(() => onError('Check Mandatory Fields and File format'));
      return;
    }

    // default upload (includes most file types)
    axiosInstance.post(`/file/upload`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((response) => { setSubmitting(false); DocCreate(response); })
      .catch(() => onError('Check Mandatory Fields and File format'));
  };

  const removeHandler = () => {
    

    const urlVerify=`/admin/application/aadhaar/admin?userId=${userId}&applicationId=${appId}`
    
    axiosInstance.get(urlVerify, {
      headers:{
      }
    })
    .then((res)=>{
      if(decode?.role==="admin")
      {
        // const a = document.createElement('a')
        // a.href = res?.data?.data?.url1
        const aadharFront = res?.data?.data?.url1?.split('.com/')[1]
        const aadharBack = res?.data?.data?.url2?.split('.com/')[1]
        const urlVerifyFront=`/file/url-content?path=${res?.data?.data?.url1?.split('.com/')[1]}`
    
        axiosInstance.get(urlVerifyFront, {
          headers:{
          }
        }).then((res)=>{
          window.open(res?.data?.data,"_blank")
          setTimeout(() => {
            const urlVerifyBack=`/file/url-content?path=${aadharBack}`
            
      
          axiosInstance.get(urlVerifyBack, {
            headers:{
            }
          }).then((res)=>{
            window.open(res?.data?.data,"_blank")
            // a.download = res?.data?.data?.url1.split('/').pop()
            // document.body.appendChild(a)
            // a.click()
            //
          })
          }, 1000);
          // a.download = res?.data?.data?.url1.split('/').pop()
          // document.body.appendChild(a)
          // a.click()
          // document.body.removeChild(a)
        })
       
        
        // const b = document.createElement('b')
        // b.href = res?.data?.data?.url2
        // b.download = res?.data?.data?.url2?.split('/').pop()
        // document.body.appendChild(b)
        // b.click()
        // document.body.removeChild(b)
      }
      else
      {
          setAadhaar(res?.data?.data)
          const c=document.getElementById('triggerAadhaar')
          c.click();
      }
    })
    .catch((err)=>{
      alert("Incorrect Password")
    }
    )
  }
  
  const onSelectHandler=(e,item)=>{
    if(downloadFileArray.find(arrItem=>arrItem===item))
     {
        downloadFileArray.splice(downloadFileArray.indexOf(item),1);
        setArrayLength(downloadFileArray.length)
     }
     else
     {
        downloadFileArray.push(item)
        setArrayLength(downloadFileArray.length)

     }
  }

  const deleteFile=(item)=>{
    
    const urlDelete='/users/documents/'
    const body={
    userId:item.userId,
    type:item.type,
    documentId:item.id,
    url1:item.url1,
    url2:item.url2

    }
    axiosInstance.post(urlDelete,body)
    .then((res)=>{
      
      alert("File Deleted")
      setTimeout(
        ()=>{
          window.location.reload()
        },1000)

    })
    .catch((err)=>{

    })

  }

  const [aadhaar,setAadhaar]=useState(null)
  const [itemPath,setitemPath] = useState(null)
  const [item2Path,setitem2Path] = useState(null)
  const [openAddFile,setOpenAddFile]=useState(false)
  const handleClick = ()=>{
    const url = `/file/url-content?path=${profileDetails?.aadhaarFrontImage}`
    axiosInstance
        .get(url, {
          headers: {
          },
        })
        .then((res)=>{
          setitemPath(res?.data?.data)
          })
          if(profileDetails?.aadhaarBackImage){
            const url1 = `/file/url-content?path=${profileDetails?.aadhaarBackImage}`
            axiosInstance
                .get(url1, {
                  headers: {
                  },
                })
                .then((res)=>{
                  setitem2Path(res?.data?.data)
                  })
          }
         
  }

  // aws video kyc upload begin
const createVideoKycRecord = (input) => {
    let docData = null;
    const preSignedurl = input.presignedUrl
    const url1 = input.presignedUrl.split('?')[0]
    if (userId) {
      setConfirmationDialog(!confirmationDialog);
      if(Type === 'video'){

        docData = {
          userId: userId,
          type: Type ==="video" ?"video":Type,
          documentId: appId,
          documentPassword:password,
          url1: url1,
          url2: input.path
        };
      }

      axiosInstance.post(`/users/documents/create/admin`, docData, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(
          (res) => {
            setConfirmationMessage('Uploaded Successfully');
            setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
            setTimeout(() => setConfirmationDialog(false), 2000);
            setTimeout(() => window.location.reload(true), 2000);
          },
          (error) => {
            setConfirmationMessage('Upload was Unsuccessful...!');
            setTimeout(() => setConfirmationDialog(!confirmationDialog), 3000);
            setTimeout(() => setConfirmationDialog(false), 3000);
          },
        );
    } else {
      alert('Fill all mandatory fields');
    }
  };

  const [progressOpen, setProgressOpen] = useState(false);
  const [progressMessage, setProgressMessage] = useState('');
  const [progressValue, setProgressValue] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  const uploadVideoToS3 = async (videoFile, type) => {
    try {
      // 1. Request pre-signed URL from backend
      setProgressMessage("Uploading video...");
      setProgressOpen(true);
      const response = await axiosInstance.get('/file/presigned-url')
      const url = response.data.data.presignedUrl

      // 2. Upload directly to S3
    const res = await axios.put(url, videoFile, {
        headers: { 'Content-Type': type },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setProgressValue(percent);
        },
      });

      setProgressOpen(false);
      setProgressValue(0);
      createVideoKycRecord(response.data.data)
      alert('Video uploaded successfully!');
      setSubmitting(false);
    } catch (err) {
      console.error('Video upload failed:', err);
      setProgressOpen(false);
      setProgressValue(0);
      alert('Video upload failed');
      setSubmitting(false);
    }
};
  // end
  const options = [
    { value: 'PAN', label: 'PAN', id: 'pan' },
    { value: 'Video', label: 'Video', id: 'video' },
    { value: 'Aadhaar Front', label: 'Aadhaar Front', id: 'aadhaar_front' },
    { value: 'Aadhaar Back', label: 'Aadhaar Back', id: 'aadhaar_back' },
    { value: 'Excel', label: 'Bank Statement Excel', id: 'excel' },
    { value: 'Driving License', label: 'Driving License', id: 'driving_license' },
    { value: 'Passport', label: 'Passport', id: 'passport' },
    { value: 'Voter ID', label: 'Voter ID', id: 'voterid' },
    { value: 'ITR', label: 'ITR', id: 'itr' },
    { value: 'Bank Statement 3m', label: 'Bank Statement 3m', id: 'bank_statement3' },
    { value: 'Bank Statement 6m', label: 'Bank Statement 6m', id: 'bank_statement6' },
    { value: 'Pay Slip 1st M', label: 'Pay Slip 1st M', id: 'pay_slip1' },
    { value: 'Pay Slip 2nd M', label: 'Pay Slip 2nd M', id: 'pay_slip2' },
    { value: 'Pay Slip 3rd M', label: 'Pay Slip 3rd M', id: 'pay_slip3' },
    { value: 'Offer letter', label: 'Offer letter', id: 'offer_letter' },
    { value: 'No Dues', label: 'No Dues', id: 'no_dues' },
    { value: 'Utility Bill', label: 'Utility Bill', id: 'utility_bill' },
    { value: 'Invoice', label: 'Invoice', id: 'invoice' },
    { value: 'Office Id', label: 'Office Id', id: 'office_id' },
    { value: 'Registration Certificate', label: 'Registration Certificate', id: 'registration_certificate' },
    { value: 'Delivery Order', label: 'Delivery Order', id: 'delivery_order' },
    { value: 'Others', label: 'Others', id: 'others' },
  ];

  const logAddharAccess = () => {
    const urlVerify = `/admin/application/aadhaar/admin?userId=${userId}&applicationId=${appId}`;
    axiosInstance.get(urlVerify)
      .then((res) => {
        if (decode?.role === 'admin') {
          const url1 = res?.data?.data?.url1;
          const aadharFront = url1 && url1.includes('.com/')
            ? url1.split('.com/')[1]
            : url1;
          const urlVerifyFront = `/file/url-content?path=${aadharFront}`;
          axiosInstance.get(urlVerifyFront).then(r => {
            window.open(r?.data?.data, '_blank');
          });
        } else {
          setAadhaar(res?.data?.data);
          const c = document.getElementById('triggerAadhaar');
          if (c) c.click();
        }
      })
      .catch(() => {
        alert('Incorrect Password');
      });
  };
  return (
    <div style={{boxShadow:'0px 0px 2px 2px  #f0f0f0',borderRadius:'15px',marginTop:'1em'}}>
       <Modal style={{overflow:'auto',height:'40em'}} size="xl" isOpen={imageOpen}>
        <ModalHeader >Uploaded File <i>( Use Scroll to Zoom in the Picture )</i> <Button style={{position: 'absolute',right:'2em'}} type="button" onClick={()=>setImageOpen(!imageOpen)}>X</Button></ModalHeader>
        <ModalBody  style={{margin:'5%',border:'2px dashed #D0D0D0',display:'block',justifyContent:'center'}} >

        {aadhaar?.type==="aadhaar"?
         <TransformWrapper
            defaultScale={1}
           >
            <TransformComponent>
               <img style={{width:'100%'}} src={itemPath} alt="File"/>
               {profileDetails?.aadhaarBackImage?<img src={item2Path} style={{width:'100%'}} alt="file"/>:null}
            </TransformComponent>
        </TransformWrapper>:null
          } 
     
        
      
          </ModalBody>
      </Modal>
      <img style={{visibility:'hidden'}} src={eye} id="triggerAadhaar" onClick={()=>{setImageOpen(!imageOpen);handleClick()}}/>
      <Modal size="lg" centered isOpen={openAddFile}>
        <ModalHeader
          style={{
            backgroundColor: '#F0F0F0',
            display: 'flex',
            justifyContent: 'center',
            fontWeight: 'bold'
          }}
        >
          Upload File
        </ModalHeader>

        <ModalBody style={{ padding: '1.5rem' }}>
          <Row>
            {/* LEFT COLUMN */}
            <Col md={6}>
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ fontWeight: 500 }}>File Category</label>
                <Select
                  options={options}
                  placeholder="Select file category"
                  onChange={handleSelect}
                />
                 {selectedValue === 'Others'  ? (
                    <span>
                      {' '}
                
                       <div>
                    <label style={{ fontWeight: 500 }}>File Name</label>
                    <input
                      className="form-control"
                      placeholder="File Name"
                      onChange={(e) => setType(e.target.value)}
                    />
                  </div>{' '}
                    <div>
                    <label style={{ fontWeight: 500 }}>Password (optional)</label>
                    <input
                      className="form-control"
                      placeholder="Enter password if any"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                    </span>
                  ) : (
                    <> {selectedValue !== '' ? <div>
                      <label style={{ fontWeight: 500 }}>Password (optional)</label>
                      <input
                        className="form-control"
                        placeholder="Enter password if any"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>:null}</>
                  )}
                {selectedValue === '' && (
                  <small style={{ color: 'red' }}>
                    Please Select a File Category
                  </small>
                )}
              </div>

             
            </Col>
              <Col md={6}>
              {showDrivingOptions ? (
                <>
                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ fontWeight: 500 }}>Choose Driving License - Front</label>
                    <input
                      type="file"
                      accept="image/*, .pdf"
                      style={{ width: '100%' }}
                      onChange={(e) => handleDrivingFileChange('front', e.target.files)}
                    />
                    {uploadedFrontName ? (
                      <div style={{ marginTop: '0.5rem', display: 'flex', alignItems: 'center' }}>
                        {frontFileType?.startsWith('image') ? (
                          <img src={fileFront ? URL.createObjectURL(fileFront) : '#'} alt="front" style={{ width: 55, height: 55, objectFit: 'cover', borderRadius: 6, border: '1px solid #E5E7EB' }} />
                        ) : null}
                        <span style={{ marginLeft: 10 }}>{uploadedFrontName}</span>
                      </div>
                    ) : null}
                  </div>

                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ fontWeight: 500 }}>Choose Driving License - Back</label>
                    <input
                      type="file"
                      accept="image/*, .pdf"
                      style={{ width: '100%' }}
                      onChange={(e) => handleDrivingFileChange('back', e.target.files)}
                    />
                    {uploadedBackName ? (
                      <div style={{ marginTop: '0.5rem', display: 'flex', alignItems: 'center' }}>
                        {backFileType?.startsWith('image') ? (
                          <img src={fileBack ? URL.createObjectURL(fileBack) : '#'} alt="back" style={{ width: 55, height: 55, objectFit: 'cover', borderRadius: 6, border: '1px solid #E5E7EB' }} />
                        ) : null}
                        <span style={{ marginLeft: 10 }}>{uploadedBackName}</span>
                      </div>
                    ) : null}
                  </div>
                </>
              ) : showVoterOptions ? (
                <>
                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ fontWeight: 500 }}>Choose Voter ID - Front</label>
                    <input
                      type="file"
                      accept="image/*, .pdf"
                      style={{ width: '100%' }}
                      onChange={(e) => handleVoterFileChange('front', e.target.files)}
                    />
                    {uploadedVoterFrontName ? (
                      <div style={{ marginTop: '0.5rem', display: 'flex', alignItems: 'center' }}>
                        {voterFrontFileType?.startsWith('image') ? (
                          <img src={voterFileFront ? URL.createObjectURL(voterFileFront) : '#'} alt="front" style={{ width: 55, height: 55, objectFit: 'cover', borderRadius: 6, border: '1px solid #E5E7EB' }} />
                        ) : null}
                        <span style={{ marginLeft: 10 }}>{uploadedVoterFrontName}</span>
                      </div>
                    ) : null}
                  </div>

                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ fontWeight: 500 }}>Choose Voter ID - Back</label>
                    <input
                      type="file"
                      accept="image/*, .pdf"
                      style={{ width: '100%' }}
                      onChange={(e) => handleVoterFileChange('back', e.target.files)}
                    />
                    {uploadedVoterBackName ? (
                      <div style={{ marginTop: '0.5rem', display: 'flex', alignItems: 'center' }}>
                        {voterBackFileType?.startsWith('image') ? (
                          <img src={voterFileBack ? URL.createObjectURL(voterFileBack) : '#'} alt="back" style={{ width: 55, height: 55, objectFit: 'cover', borderRadius: 6, border: '1px solid #E5E7EB' }} />
                        ) : null}
                        <span style={{ marginLeft: 10 }}>{uploadedVoterBackName}</span>
                      </div>
                    ) : null}
                  </div>
                </>
                ) : showPassportOptions ? (
                <>
                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ fontWeight: 500 }}>Choose Passport - Front</label>
                    <input
                      type="file"
                      accept="image/*, .pdf"
                      style={{ width: '100%' }}
                      onChange={(e) => handlePassportFileChange('front', e.target.files)}
                    />
                    {uploadedPassportFrontName ? (
                      <div style={{ marginTop: '0.5rem', display: 'flex', alignItems: 'center' }}>
                        {passportFrontFileType?.startsWith('image') ? (
                          <img src={passportFileFront ? URL.createObjectURL(passportFileFront) : '#'} alt="front" style={{ width: 55, height: 55, objectFit: 'cover', borderRadius: 6, border: '1px solid #E5E7EB' }} />
                        ) : null}
                        <span style={{ marginLeft: 10 }}>{uploadedPassportFrontName}</span>
                      </div>
                    ) : null}
                  </div>

                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ fontWeight: 500 }}>Choose Passport - Back</label>
                    <input
                      type="file"
                      accept="image/*, .pdf"
                      style={{ width: '100%' }}
                      onChange={(e) => handlePassportFileChange('back', e.target.files)}
                    />
                    {uploadedPassportBackName ? (
                      <div style={{ marginTop: '0.5rem', display: 'flex', alignItems: 'center' }}>
                        {passportBackFileType?.startsWith('image') ? (
                          <img src={passportFileBack ? URL.createObjectURL(passportFileBack) : '#'} alt="back" style={{ width: 55, height: 55, objectFit: 'cover', borderRadius: 6, border: '1px solid #E5E7EB' }} />
                        ) : null}
                        <span style={{ marginLeft: 10 }}>{uploadedPassportBackName}</span>
                      </div>
                    ) : null}
                  </div>
                </>
              ) : (
                <>
                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ fontWeight: 500 }}>Choose File</label>
                    <input
                        type="file"
                        accept="video/*, image/*, .pdf, .xlsx, .xls"
                        style={{ width: '100%' }}
                        onChange={(e) => handleChange(e.target.files)}
                      />
                  </div>

                  <div>
                    <label style={{ fontWeight: 500 }}>Preview</label><br/>
                   {uploaded && fileType?.startsWith('image')
                    ? 
                    (
                        <>
                          <img
                            src={preview}
                            alt="preview"
                            style={{
                              width: '55px',
                              height: '55px',
                              objectFit: 'cover',
                              borderRadius: '6px',
                              border: '1px solid #E5E7EB'
                            }}
                          />
                          <Button
                            color="link"
                            style={{ padding: 0, fontSize: '13px',marginLeft:'10px' }}
                            onClick={removeHandler}
                          >
                            Remove file
                          </Button>
                        </>
                    ):
                    (uploaded && fileType?.startsWith('image') ? <p style={{ color: '#667085' }}>No preview available (Upload to See)</p>:<p>{uploadedFileName}</p> )
                    
                    }
                  </div>
                </>
              )}
            </Col>            
          </Row>
          {ocrLoading && (
            <div style={{ marginTop: '1rem', textAlign: 'center' }}>
              <LinearProgress />
              <p style={{ marginTop: '0.5rem', color: '#667085' }}>
                Reading document, please wait...
              </p>
            </div>
            )}

            {ocrSuccess && ['voterid','voterid_front','voterid_back','passport_front','passport_back', 'driving_license_front','driving_license_back', 'passport'].includes(Type) && ocrData && (
              <div style={{ marginTop: '1.5rem' }}>
                <Row>
                  {/* NAME */}
                  <Col md={Type === 'voterid' || Type === 'passport' || Type === 'passport_front' || Type === 'passport_back' ? 6 : 4}>
                    <label>Name</label>
                    <input
                      className="form-control"
                      value={ocrData.name}
                      onChange={(e) => handleOcrInputChange('name', e.target.value)}
                    />
                  </Col>

                  {/* ID NUMBER */}
                  {Type !== 'passport' && Type !== 'passport_front' && Type !== 'passport_back' && (
                    <Col md={Type === 'voterid' ? 6 : 4}>
                    <label>ID Number</label>
                    <input  
                      className="form-control"
                      value={ocrData.idNumber}
                      onChange={(e) => handleOcrInputChange('idNumber', e.target.value)}
                    />
                  </Col>
                  )}
                
                  {/* DOB → ONLY FOR DRIVING LICENSE */}
                  {(Type === 'driving_license_front' || Type === 'driving_license_back') && (
                    <Col md={4}>
                      <label>Date of Birth</label>
                      <input
                        className="form-control"
                        value={ocrData.dob}
                        onChange={(e) => handleOcrInputChange('dob', e.target.value)}
                      />
                    </Col>
                  )}
                  {(Type === 'passport' || Type === 'passport_front' || Type === 'passport_back') && (
                      <>
                        

                        <Col md={6}>
                          <label>Passport Number</label>
                          <input
                            className="form-control"
                            value={ocrData.passportNumber}
                            onChange={(e) => handleOcrInputChange('passportNumber', e.target.value)}
                          />
                        </Col>

                        <Col md={4}>
                          <label>Date of Birth</label>
                          <input
                            className="form-control"
                            value={ocrData.dob}
                            onChange={(e) => handleOcrInputChange('dob', e.target.value)}
                          />
                        </Col>

                        <Col md={4}>
                          <label>Expiry Date</label>
                          <input
                            className="form-control"
                            value={ocrData.expiryDate}
                            onChange={(e) => handleOcrInputChange('expiryDate', e.target.value)}
                          />
                        </Col>

                        <Col md={4}>
                          <label>Gender</label>
                          <input
                            className="form-control"
                            value={ocrData.gender}
                            onChange={(e) => handleOcrInputChange('gender', e.target.value)}
                          />
                        </Col>
                      </>
                    )}

                </Row>
              </div>
          )}
          {verifyLoading && (
            <div style={{ marginTop: '1rem', textAlign: 'center' }}>
              <LinearProgress />
              <p style={{ marginTop: '0.5rem', color: '#667085' }}>
                Verifying details, please wait...
              </p>
            </div>
          )}
          {verifyError && (
            <div
              style={{
                marginTop: '1rem',
                color: '#d92d20',
                background: '#fff1f0',
                padding: '8px 12px',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            >
              {verifyError}
            </div>
          )}
          {verifySuccess && (
            <div
              style={{
                marginTop: '1rem',
                color: '#067647',
                background: '#ecfdf3',
                padding: '4px 6px',
                borderRadius: '6px',
                fontSize: '14px',
                border: '1px solid #a6f4c5',
                width: '22%',
                marginLeft: '39%'
              }}
            >
              {verifySuccess}
            </div>
          )}

          {uploaded && ocrSuccess && !verifyLoading && (
            (['voterid','voterid_front','voterid_back','passport_front','passport_back', 'driving_license_front', 'driving_license_back', 'passport'].includes(Type) || showDrivingOptions || showVoterOptions || showPassportOptions) ? (
              <Button
                disabled={verifyLoading || submitting}
                style={{
                  marginTop: '1.5rem',
                  width: '22%',
                  backgroundColor: '#d32028',
                  border: 'none',
                  marginLeft: '39%'
                }}
                onClick={handleVerifyAndSubmit}
              >
                {verifyLoading ? 'Verifying...' : submitting ? 'Submitting...' : 'Verify & Submit'}
              </Button>
            ) : (
              <Button
                disabled={submitting}
                style={{
                  marginTop: '1.5rem',
                  width: '15%',
                  backgroundColor: '#d32028',
                  border: 'none',
                  marginLeft: '40%'
                }}
                onClick={() => handleSubmission(file)}
              >
                {submitting ? 'Submitting...' : 'Submit'}
              </Button>
            )
          )}


        </ModalBody>

        <ModalFooter>
          <Button outline onClick={() => setOpenAddFile(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <div style={{ padding:'1em',display:'flex',justifyContent: 'flex-end',  marginTop: '-2.5em'}}>  
        <div style={{display:'flex'}}>
          {arrayLength?<img style={{cursor:'pointer'}} src={downloadFile}/>:null}
        <img style={{cursor:'pointer'}} onClick={()=>setOpenAddFile(true)} src={addNew} alt='Add New file'/>
        </div>
      </div>

         <div style={{
            borderRadius: '5px',
            padding: '1em',
            fontFamily: 'Inter, sans-serif',
            overflowX: 'auto',
            marginTop:'-1.5em'
          }}>
  <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 12px' }}>
    <thead style={{ backgroundColor: '#f0f3f5ff', height: '3em', color: '#344054', fontSize: '15px', fontWeight: 500 }}>
      <tr>
        <th style={{ textAlign: 'left', paddingLeft: '1em' }}>
          <input style={{ height: '1em', width: '1.2em' }} type="checkbox" />
        </th>
        <th style={{ textAlign: 'left' }}>File Name</th>
        <th style={{ textAlign: 'left' }}>Date Uploaded</th>
        <th style={{ textAlign: 'left' }}>File Type</th>
        <th style={{ textAlign: 'left' }}>Password (if any)</th>
         <th style={{ textAlign: 'left' }}>Created By</th>
        <th style={{ textAlign: 'left',paddingLeft:'20px' }}>Action</th>
      </tr>
    </thead>
    <tbody>
      {fileList?.filter(item => item.type?.toLowerCase() !== 'aadhaar')?.map((item, index) => (
        <tr key={index} style={{
          backgroundColor: '#fff',
          boxShadow: '0px 1px 3px rgba(0,0,0,0.05)',
          borderRadius: '8px',
          fontSize: '15px',
          height: '3.2em'
        }}>
          <td style={{ textAlign: 'left', paddingLeft: '1em', width: '4em' }}>
            <input onClick={(e) => onSelectHandler(e, item)} style={{ height: '1em', width: '1.2em' }} type="checkbox" />
          </td>
          <td style={{ textAlign: 'left', paddingLeft: '0.5em' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={documentImage} alt="doc" style={{ maxHeight: '30px', marginRight: '8px' }} />
              <span title={item.type} style={{
                maxWidth: '150px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>{item.type}</span>
            </div>
          </td>
          <td style={{ textAlign: 'left' }}>{moment(item.updatedAt).format('DD MMM YYYY')}</td>
          <td style={{ textAlign: 'left' }}>
             <div style={{ display: 'flex', alignItems: 'center' }}>
              <span title={item.type} style={{
                maxWidth: '150px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>{item.type}</span> </div>
          </td>
          <td style={{ textAlign: 'left' }}>{item.documentPassword || "--"}</td>
           <td style={{ textAlign: 'left', paddingLeft:'10px'}}>{item.doneBy || "--"}</td>
          <td style={{ textAlign: 'left',paddingLeft:'20px' }}>
            <div style={{
              display: 'flex',
              gap: '1em',
              flexWrap: 'wrap',
              marginTop: '0.5em'
            }}>
              <ViewFile
                currUserId={item.userId}
                currApplicationId={appId}
                type={item.type}
                item={item.url1}
                item2={item.url2}
                image={eye}
                profileDetails={profileDetails}
              />
              {(location.pathname === "/status/submission/profile" || location.pathname === "/status/review/profile") &&
                <img style={{ cursor: 'pointer', maxWidth: '20px' }} onClick={() => deleteFile(item)} src={dele} alt="delete" />}
            </div>
          </td>
        </tr>
      ))}

      {/* Aadhaar row */}
      {fileList?.filter(item => item.type?.toLowerCase() === 'aadhaar')?.map((item, index) => (
        <tr key={`aadhaar-${index}`} style={{
          backgroundColor: '#fff',
          boxShadow: '0px 1px 3px rgba(0,0,0,0.05)',
          borderRadius: '8px',
          fontSize: '14px',
          height: '3.2em'
        }}>
          <td style={{ textAlign: 'left', paddingLeft: '1em' }}>
            <input style={{ height: '1em', width: '1.2em' }} type="checkbox" />
          </td>
          <td style={{ textAlign: 'left', paddingLeft: '0.5em' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={documentImage} alt="doc" style={{ maxHeight: '30px', marginRight: '8px' }} />
              <span title="Aadhaar" style={{
                maxWidth: '150px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>Aadhaar</span>
            </div>
          </td>
          <td style={{ textAlign: 'left' }}>Hidden</td>
          <td style={{ textAlign: 'left' }}>Image</td>
          <td style={{ textAlign: 'left' }}>--</td>
            <td style={{ textAlign: 'left' }}>{item.doneBy || "--"}</td>
          <td style={{ textAlign: 'left' }}>
            <div style={{
              display: 'flex',
              gap: '1.5em',
              marginTop: '0.5em',
              flexWrap: 'wrap'
            }}>
              {decode?.role === "admin" ? (
                <>
                  <img src={downloadFile} alt="download" style={{ width: '5em', cursor: 'pointer' }} onClick={() => logAddharAccess()} />
                  {(location.pathname === "/status/submission/profile" || location.pathname === "/status/review/profile") &&
                    <img style={{ cursor: 'pointer', width: '1.5em', height: '1.7em' }} onClick={() => deleteFile()} src={dele} alt="delete" />}
                </>
              ) : (
                <>
                  <img src={eye} alt="view" style={{ cursor: 'pointer', margin: '0 20px' }} onClick={() => logAddharAccess()} />
                  {(location.pathname === "/status/submission/profile" || location.pathname === "/status/review/profile") &&
                    <img style={{ cursor: 'pointer' }} onClick={() => deleteFile()} src={dele} alt="delete" />}
                </>
              )}
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>



        {/* video upload progress bar modal begin */}
        <Dialog open={progressOpen} onClose={() => {}} maxWidth="xs" fullWidth>
          <DialogTitle>Processing...</DialogTitle>
          <DialogContent>
            <Typography variant="body2" gutterBottom>
              {progressMessage}
            </Typography>
            <LinearProgress variant="determinate" value={progressValue} />
            <Typography variant="caption" display="block" align="right" style={{ marginTop: '4px' }}>
              {progressValue}%
            </Typography>
          </DialogContent>
        </Dialog>

        {/* video upload progress bar modal ends */}
    </div>
  )
}
